import { useState, useEffect, useMemo } from "react";
import * as bp from "@ottomotors/ottomotors-common/styles/breakpoints.module.scss";

export type TBreakpoint =
  | `giant`
  | `largeDesktop`
  | `desktop`
  | `smallDesktop`
  | `largeTablet`
  | `tablet`
  | `smallTablet`
  | `largeMobile`
  | `mobile`
  | `smallMobile`;

type TBreakpoints = {
  [key in TBreakpoint]: boolean;
};

const useBreakpoints = () => {
  const [breakpoints, setBreakpoints] = useState<TBreakpoints>({
    ...bp,
  });

  const bpArray = useMemo(() => Object.keys(bp), []);

  const parseBpStringToInt = (bpStringWithPx: string) =>
    parseInt(bpStringWithPx.replace(`px`, ``));

  useEffect(() => {
    const handleResize = () => {
      const updatedBreakpoints: TBreakpoints = {} as TBreakpoints;

      for (let i = 0; i < bpArray.length; i += 1) {
        updatedBreakpoints[bpArray[i] as TBreakpoint] =
          window.innerWidth >= parseBpStringToInt(bp[bpArray[i]]);
      }

      setBreakpoints(updatedBreakpoints);
    };

    window.addEventListener(`resize`, handleResize);

    handleResize();

    return () => window.removeEventListener(`resize`, handleResize);
  }, [bpArray]);

  return breakpoints;
};

export default useBreakpoints;
